import { render, staticRenderFns } from "./WalletWidget.vue?vue&type=template&id=2e2da9db&"
import script from "./WalletWidget.vue?vue&type=script&lang=js&"
export * from "./WalletWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports